﻿<script>
	import { siteSettings } from "../config";
	import model from "../stores/modelStore";

	import Form from "../components/Form.svelte";
	import NavigationButtons from "../components/NavigationButtons.svelte";

	let buttons;

	const handleSubmit = async (e) => {
		//e.preventDefault();
		buttons.blockNext();
		buttons.next();
		buttons.unblock();
	};
</script>

<Form id="landing-page" on:submit={handleSubmit}>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank You</h1>

			<p>Thank you for your enquiry with Shine Lawyers.</p>

			<p>Your survey ID is {$model.SurveyReferenceNumber}</p>

			<p>What happens next?</p>

			<ol>
				<li>
					Sign your Authority, (by clicking on the button below) this
					allows us to obtain information from your Super Fund.
				</li>
				<li>
					We will be in touch once we have heard back from your Super
					Fund(s) or Personal Insurer to advise you on your
					entitlements. Please note, it can take up to 4 weeks to hear
					back regarding your entitlements.
				</li>
			</ol>

			<p>
				In the meantime if you have any questions, you can contact us on
				{siteSettings.phoneNumber}, or <a
						href="mailto:{siteSettings.emailAddress}"
						title="Email Super {siteSettings.emailAddress}">{siteSettings.emailAddress}</a>.
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center register-btn form-group">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons bind:buttons />
		</div>
	</div>
</Form>
